export function getdata() {
	var obj = {
		searchlist: [{
				prop: "nsrmc",
				label: '纳税人名称',
				type: "input"
			},
			{
				prop: "nsrsbh",
				label: '纳税人识别号',
				type: "input"
			},
			{
				prop: "yingnse",
				label: '应纳税额',
				type: "inputplus"
			},
			{
				prop: "jianmse",
				label: '减免税额',
				type: "inputplus"
			},
			{
				prop: "yjse",
				label: '已缴税额',
				type: "inputplus"
			},
			{
				prop: "ybtsehj",
				label: '应补(退)税额合计',
				type: "inputplus"
			},
			{
				prop: "mingxts",
				label: '明细条数',
				type: "input",
			},
		],
		tableJson: "{\n" + "  \"searchList\":[\n" + "    {\n" + "      \"name\":\"纳税人名称\",\n" +
			"      \"column\":\"nsrmc\",\n" + "      \"originName\":\"纳税人名称\",\n" + "      \"show\":\"0\"\n" +
			"    },\n" + "    {\n" + "      \"name\":\"纳税人识别号\",\n" + "      \"column\":\"nsrsbh\",\n" +
			"      \"originName\":\"纳税人识别号\",\n" + "      \"show\":\"0\"\n" + "    },\n" + "    {\n" +
			"      \"name\":\"公司编号\",\n" + "      \"column\":\"company_no\",\n" +
			"      \"originName\":\"公司编号\",\n" + "      \"show\":\"1\"\n" + "    },\n" + "    {\n" +
			"      \"name\":\"应纳税额\",\n" + "      \"column\":\"yingnse\",\n" + "      \"originName\":\"应纳税额\",\n" +
			"      \"show\":\"0\"\n" + "    },\n" + "    {\n" + "      \"name\":\"减免税额\",\n" +
			"      \"column\":\"jianmse\",\n" + "      \"originName\":\"减免税额\",\n" + "      \"show\":\"0\"\n" +
			"    },\n" + "\n" + "    {\n" + "      \"name\":\"已缴税额\",\n" + "      \"column\":\"yjse\",\n" +
			"      \"originName\":\"已缴税额\",\n" + "      \"show\":\"0\"\n" + "    },\n" + "    {\n" +
			"      \"name\":\"应补(退)税额合计\",\n" + "      \"column\":\"ybtsehj\",\n" +
			"      \"originName\":\"应补(退)税额合计\",\n" + "      \"show\":\"0\"\n" + "    },\n" + "\n" + "    {\n" +
			"      \"name\":\"明细条数\",\n" + "      \"column\":\"mingxts\",\n" + "      \"originName\":\"明细条数\",\n" +
			"      \"show\":\"0\"\n" + "    },\n" + "    {\n" + "      \"name\":\"数据来源\",\n" +
			"      \"column\":\"shujly\",\n" + "      \"originName\":\"数据来源\",\n" + "      \"show\":\"0\"\n" +
			"    },\n" + "    {\n" + "      \"name\":\"所属期\",\n" + "      \"column\":\"suosq\",\n" +
			"      \"originName\":\"所属期\",\n" + "      \"show\":\"1\"\n" + "    },\n" + "    {\n" +
			"      \"name\":\"修改时间\",\n" + "      \"column\":\"updateTime\",\n" +
			"      \"originName\":\"修改时间\",\n" + "      \"show\":\"0\"\n" + "    },\n" + "    {\n" +
			"      \"name\":\"创建人\",\n" + "      \"column\":\"updateBy\",\n" + "      \"originName\":\"创建人\",\n" +
			"      \"show\":\"0\"\n" + "    }\n" + "  ],\n" + "  \"headData\":\n" + "  [\n" + "    {\n" +
			"      \"name\":\"纳税人名称\",\n" + "      \"column\":\"nsrmc\",\n" + "      \"originName\":\"纳税人名称\",\n" +
			"      \"show\":\"0\"\n" + "    },\n" + "    {\n" + "      \"name\":\"纳税人识别号\",\n" +
			"      \"column\":\"nsrsbh\",\n" + "      \"originName\":\"纳税人识别号\",\n" + "      \"show\":\"0\"\n" +
			"    },\n" + "    {\n" + "      \"name\":\"公司编号\",\n" + "      \"column\":\"company_no\",\n" +
			"      \"originName\":\"公司编号\",\n" + "      \"show\":\"1\"\n" + "    },\n" + "    {\n" +
			"      \"name\":\"应纳税额\",\n" + "      \"column\":\"yingnse\",\n" + "      \"originName\":\"应纳税额\",\n" +
			"      \"show\":\"0\"\n" + "    },\n" + "    {\n" + "      \"name\":\"减免税额\",\n" +
			"      \"column\":\"jianmse\",\n" + "      \"originName\":\"减免税额\",\n" + "      \"show\":\"0\"\n" +
			"    },\n" + "\n" + "    {\n" + "      \"name\":\"已缴税额\",\n" + "      \"column\":\"yjse\",\n" +
			"      \"originName\":\"已缴税额\",\n" + "      \"show\":\"0\"\n" + "    },\n" + "    {\n" +
			"      \"name\":\"应补(退)税额合计\",\n" + "      \"column\":\"ybtsehj\",\n" +
			"      \"originName\":\"应补(退)税额合计\",\n" + "      \"show\":\"0\"\n" + "    },\n" + "\n" + "    {\n" +
			"      \"name\":\"明细条数\",\n" + "      \"column\":\"mingxts\",\n" + "      \"originName\":\"明细条数\",\n" +
			"      \"show\":\"0\"\n" + "    },\n" + "    {\n" + "      \"name\":\"数据来源\",\n" +
			"      \"column\":\"shujly\",\n" + "      \"originName\":\"数据来源\",\n" + "      \"show\":\"0\"\n" +
			"    },\n" + "    {\n" + "      \"name\":\"所属期\",\n" + "      \"column\":\"suosq\",\n" +
			"      \"originName\":\"所属期\",\n" + "      \"show\":\"1\"\n" + "    },\n" + "    {\n" +
			"      \"name\":\"修改时间\",\n" + "      \"column\":\"updateTime\",\n" +
			"      \"originName\":\"修改时间\",\n" + "      \"show\":\"0\"\n" + "    },\n" + "    {\n" +
			"      \"name\":\"创建人\",\n" + "      \"column\":\"updateBy\",\n" + "      \"originName\":\"创建人\",\n" +
			"      \"show\":\"0\"\n" + "    }\n" + "  ],\n" + "  \"formlist\":[\n" + "    {\n" +
			"      \"name\":\"纳税人名称\",\n" + "      \"column\":\"nsrmc\",\n" + "      \"originName\":\"纳税人名称\",\n" +
			"      \"show\":\"0\"\n" + "    },\n" + "    {\n" + "      \"name\":\"纳税人识别号\",\n" +
			"      \"column\":\"nsrsbh\",\n" + "      \"originName\":\"纳税人识别号\",\n" + "      \"show\":\"0\"\n" +
			"    },\n" + "    {\n" + "      \"name\":\"公司编号\",\n" + "      \"column\":\"company_no\",\n" +
			"      \"originName\":\"公司编号\",\n" + "      \"show\":\"1\"\n" + "    },\n" + "    {\n" +
			"      \"name\":\"应纳税额\",\n" + "      \"column\":\"yingnse\",\n" + "      \"originName\":\"应纳税额\",\n" +
			"      \"show\":\"0\"\n" + "    },\n" + "    {\n" + "      \"name\":\"减免税额\",\n" +
			"      \"column\":\"jianmse\",\n" + "      \"originName\":\"减免税额\",\n" + "      \"show\":\"0\"\n" +
			"    },\n" + "\n" + "    {\n" + "      \"name\":\"已缴税额\",\n" + "      \"column\":\"yjse\",\n" +
			"      \"originName\":\"已缴税额\",\n" + "      \"show\":\"0\"\n" + "    },\n" + "    {\n" +
			"      \"name\":\"应补(退)税额合计\",\n" + "      \"column\":\"ybtsehj\",\n" +
			"      \"originName\":\"应补(退)税额合计\",\n" + "      \"show\":\"0\"\n" + "    },\n" + "\n" + "    {\n" +
			"      \"name\":\"明细条数\",\n" + "      \"column\":\"mingxts\",\n" + "      \"originName\":\"明细条数\",\n" +
			"      \"show\":\"0\"\n" + "    },\n" + "    {\n" + "      \"name\":\"数据来源\",\n" +
			"      \"column\":\"shujly\",\n" + "      \"originName\":\"数据来源\",\n" + "      \"show\":\"0\"\n" +
			"    },\n" + "    {\n" + "      \"name\":\"所属期\",\n" + "      \"column\":\"suosq\",\n" +
			"      \"originName\":\"所属期\",\n" + "      \"show\":\"1\"\n" + "    },\n" + "    {\n" +
			"      \"name\":\"修改时间\",\n" + "      \"column\":\"updateTime\",\n" +
			"      \"originName\":\"修改时间\",\n" + "      \"show\":\"0\"\n" + "    },\n" + "    {\n" +
			"      \"name\":\"创建人\",\n" + "      \"column\":\"updateBy\",\n" + "      \"originName\":\"创建人\",\n" +
			"      \"show\":\"0\"\n" + "    }\n" + "  ]\n" + "}",
		searchdata: {
			nsrmc: "",
			nsrsbh: "",
			yingnse: [],
			jianmse: [],
			yjse: [],
			ybtsehj: [],
			mingxts: ""
		},
		headData: [{
				title: "纳税人名称",
				prop: "nsrmc",
				width: 160,
				custom: true,

			},
			{
				title: "纳税人识别号",
				prop: "nsrsbh",
				width: 160,
				custom: true,

			},
			{
				title: "应纳税额",
				prop: "yingnse",
				width: "80",
				AmountFormat: true,
				custom: true,

			},
			{
				title: "减免税额",
				prop: "jianmse",
				width: "80",
				AmountFormat: true,
				custom: true,

			},
			{
				title: "已缴税额",
				prop: "yjse",
				width: "80",
				AmountFormat: true,
				custom: true,

			},
			{
				title: "应补（退）税额合计",
				prop: "ybtsehj",
				width: "140",
				AmountFormat: true,
				custom: true,

			},
			{
				title: "明细条数",
				prop: "mingxts",
				width: "80",
				custom: true,

			},
			{
				title: "操作",
				prop: "cz",
				custom: true,
				fixed: "right",
				width: "250"
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}
	}
	return obj
}
